const BLOG_DATE_TIME_ZONE = 'Europe/Paris';

type BlogDateStyle = 'short' | 'long';

export const formatBlogDate = (date: string, style: BlogDateStyle = 'short') =>
  new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: style === 'long' ? 'long' : 'short',
    year: 'numeric',
    timeZone: BLOG_DATE_TIME_ZONE,
  }).format(new Date(`${date}T12:00:00+01:00`));

export const getBlogDateTimestamp = (date: string) =>
  Date.parse(`${date}T12:00:00+01:00`);
